/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { OrganizationDetailResponse } from '../types/OrganizationDetail';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type OrganizationsRetrieveRequest = {} | null | undefined;
export type OrganizationsRetrieveResponse = OrganizationDetailResponse;

export type OrganizationsRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this organization.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/organizations/{id}/
 *
 * ```yaml
 * operationId: organizations_retrieve
 * tags:
 *   - organizations
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrganizationDetail'
 *     description: ''
 * ```
 */
export const organizationsRetrieveOperation = ({ id, ...rest }: OrganizationsRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/organizations/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/organizations/{id}/' };
  };

/**
 * GET /dmx-server/organizations/{id}/
 *
 * ```yaml
 * operationId: organizations_retrieve
 * tags:
 *   - organizations
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrganizationDetail'
 *     description: ''
 * ```
 */
export const organizationsRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: OrganizationsRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<OrganizationDetailResponse>> => {
  const operation = organizationsRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/organizations/{id}/
 */
export const useOrganizationsRetrieveResource = (
  query: OrganizationsRetrieveQuery | null,
  useCached?: boolean,
): UseResource<OrganizationsRetrieveResponse> => {
  return useResource<OrganizationsRetrieveResponse>({
    path: query === null ? null : organizationsRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
